import React, { useState,useEffect,useRef, useCallback } from 'react';
import { AnimatePresence,motion } from 'framer-motion';
import useEmblaCarousel from 'embla-carousel-react'

import '../../lib/bootstrap.min.css'
import '../Main.css';
import '../SubPage.css';
import '../Property.css';

const Home = (props) => {
    const refContent = useRef(null);
    const [cheight,setcHeight] = useState(0)
    const [cwidth,setcWidth] = useState(0)
    const [emblaRef, emblaApi] = useEmblaCarousel()
    const [greeting,setGreeting] = useState()


    function nl2br (str, replaceMode, isXhtml) {
        var breakTag = (isXhtml) ? '<br />' : '<br>';
        var replaceStr = (replaceMode) ? '$1'+ breakTag : '$1'+ breakTag +'$2';
        return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, replaceStr);
      }

    useEffect(() => {
        var greeting = ''
        console.log(props.content.filter((object_profile)=> object_profile.object === 'greeting').length)
        if(props.content.length > 0){ 
            try {
              greeting = props.content.filter((_profile)=> _profile.object === 'greeting')[0].value
            } catch (err) {
              console.error("Error handled:", err);
            }

            if(props.reservation === null){
                greeting = greeting.replace("{room}",'No Room')
                greeting = greeting.replace("{guest}",'Guest')
                setGreeting(greeting)
            }else{
                greeting = greeting.replace("{room}",props.reservation.room_name)
                if(props.reservation.reservation_active.length > 0){
                    greeting = greeting.replace("{guest}",props.reservation.reservation_active[0].guest_name)
                }else{
                    greeting = greeting.replace("{guest}",'Guest')
                }
                setGreeting(greeting)
            }
        }
        setcHeight(refContent.current.clientHeight);
        setcWidth(refContent.current.clientWidth);
    }, []);

  return (
     <motion.div ref={refContent} style={{height:props.height}}>
        <div className="home-content" style={{padding:'30px 50px'}}>
            <div dangerouslySetInnerHTML={{__html: nl2br(greeting)}} style={{fontSize:14, lineHeight:'20px'}}></div>
        </div>
    </motion.div>
  )};

export default Home;


